import { TrendingPacks } from '@bpm-web-app/components/pages';

export default function Trending() {
    return <TrendingPacks />;
}
